<template>
  <div>
    <follow-up readonly :initial-data="initialData" />
    <validation-observer ref="formRef">
      <div class="mt-4">
        <div class="d-flex align-items-center mb-3">
          <em class="fas fa-calendar-alt text-orange mr-2" />
          <span class="color-secondary-29 font-14" style="font-weight: 600">
            Cierre de Año
          </span>
        </div>
        <div class="row">
          <div class="col">
            <validation-provider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <custom-drop-down
                v-model="status"
                label="Estatus del Plan de Acción:"
                placeholder="Seleccione"
                fieldkey="id"
                fieldname="name"
                :options="statusOptions"
                :error="errors[0]"
                custom-error-msg="El estatus del plan de acción es requerido."
                @input="handleChangeStatus"
              />
            </validation-provider>
          </div>
          <div v-if="!isExtendedStatusSelected" class="col">
            <validation-provider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <custom-date-picker
                v-model="closingDate"
                class-container=""
                label="Fecha de Cierre:"
                placeholder="DD/MM/YYYY"
                :max-date="new Date()"
                :error="errors[0]"
                custom-error-msg="La fecha de cierre es requerida."
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-3">
            <validation-provider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <custom-text-area
                v-model="comment"
                required
                show-char-count
                label="Comentario:"
                custom-error-msg="El comentario es requerido."
                :maxlength="3000"
                :error="errors[0]"
                :count-classes="['d-block', 'small-counter', 'text-right']"
              />
            </validation-provider>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger px-4 mr-3"
            @click="handleCancel"
          />
          <action-button
            i="fa fa-save"
            text="Guardar"
            variant="success px-4"
            @click="handleSave"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
// libs
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

// child components
import FollowUp from './FollowUp.vue';

// mixins
import alertMixin from '@/mixin/alert.mixin';

// constants
import actionPlanStatus, {
  actionPlanStatusNames,
} from '@/utils/constants/tapRequest/alternativeLocationActionPlanStatus.js';

export default {
  name: 'YearClosing',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    CustomDatePicker,
    CustomTextArea,
    ActionButton,
    FollowUp,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      status: undefined,
      closingDate: undefined,
      comment: undefined,
    };
  },
  computed: {
    statusOptions() {
      return [actionPlanStatus.Atendido, actionPlanStatus.Extendido].map(
        (id) => ({
          id,
          name: actionPlanStatusNames[id],
        })
      );
    },
    isExtendedStatusSelected() {
      return this.status?.id === actionPlanStatus.Extendido;
    },
  },
  methods: {
    handleChangeStatus() {
      this.closingDate = undefined;
    },
    async handleSave() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar los campos requeridos.',
          'error'
        );
        return;
      }
      const payload = {
        servedFlag: this.status.id === actionPlanStatus.Atendido,
        closingDate: this.closingDate,
        comment: this.comment,
      };
      this.$emit('save', { ...payload });
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
